import { Col, Row } from 'react-bootstrap'
import Dropdown from '../../../../../sharedComponent/Dropdown/Dropdown'
import ElectricIcon from '../../../../../../_metronic/images/gas-icon.png'
import { restrictDecimal } from '../../../../../../utils/helper'
import { productFieldConfig } from './AddProduct.types'
import { billingMethodOptions } from '../AddProductUtils'
import { gRatePlaceHolder } from '../../../../../../utils/GlobalConstants'

const GasProperty = ({
  utilityData,
  handleSelectedItem,
  formik,
  contractTypeData,
  unitData,
  preventScroll,
  isDynamicProducts,
}: any) => {
  const onChangeRestrictDecimal = (e: any, fieldName: string) => {
    formik.setFieldValue(fieldName, restrictDecimal(e.target.value))
  }
  const gasConfigs: productFieldConfig[] = [
    {
      fieldTitle: 'G_Utility',
      fieldName: 'gutility',
      type: 'DROPDOWN',
      data: utilityData,
      isMandatory: true,
    },
    {
      fieldTitle: 'G_Contract Type',
      fieldName: 'gcontractType',
      type: 'DROPDOWN',
      data: contractTypeData,
      isMandatory: true,
    },
    {
      fieldTitle: 'G_Unit',
      fieldName: 'gunit',
      type: 'DROPDOWN',
      data: unitData,
      isMandatory: true,
    },
    {
      fieldTitle: 'G_Rate',
      fieldName: 'grate',
      type: 'number',
      isMandatory: true,
      handleChange: onChangeRestrictDecimal,
      placeHolder: gRatePlaceHolder,
    },
    {
      fieldTitle: 'G_Second Rate ($)',
      fieldName: 'gsecondRate',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Second Rate',
    },
    {
      fieldTitle: 'G_Term',
      fieldName: 'gterm',
      type: 'number',
      isMandatory: false,
      placeHolder: 'Enter G_term',
    },
    {
      fieldTitle: 'G_Early Termination Fee ($)',
      fieldName: 'gearlyTerminationFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Early Termination Fee',
    },
    {
      fieldTitle: 'G_Service Fee ($)',
      fieldName: 'gserviceFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_service Fee',
    },
    {
      fieldTitle: 'G_Adder ($)',
      type: 'number',
      fieldName: 'gadded',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Adder',
    },
    {
      fieldTitle: 'G_Deposit ($)',
      type: 'number',
      fieldName: 'gdeposit',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Deposit',
    },
    {
      fieldTitle: 'G_Product Code',
      type: 'text',
      fieldName: 'gcode',
      isMandatory: true,
      placeHolder: 'Enter G_product Code',
    },
    {
      fieldTitle: 'G_Billing Method',
      type: 'DROPDOWN',
      fieldName: 'gbillingMethod',
      isMandatory: true,
      data: [
        {
          id: 'MarketerBillReady',
          value: 'MarketerBillReady',
          type: 'billingMethod',
        },
        {
          id: 'UtilityBillReady',
          value: 'UtilityBillReady',
          type: 'billingMethod',
        },
        {
          id: 'UtilityRateReady',
          value: 'UtilityRateReady',
          type: 'billingMethod',
        },
        {
          id: 'Dual',
          value: 'Dual',
          type: 'billingMethod',
        },
      ],
    },
  ]
  const dynamicgasConfigs: productFieldConfig[] = [
    {
      fieldTitle: 'G_Utility',
      fieldName: 'gutility',
      type: 'DROPDOWN',
      data: utilityData,
      isMandatory: true,
    },
    {
      fieldTitle: 'G_Contract Type',
      fieldName: 'gcontractType',
      type: 'DROPDOWN',
      data: contractTypeData,
      isMandatory: true,
    },
    {
      fieldTitle: 'G_Unit',
      fieldName: 'gunit',
      type: 'DROPDOWN',
      data: unitData,
      isMandatory: true,
    },
    {
      fieldTitle: 'Minimum G_Rate',
      fieldName: 'grateMinimum',
      type: 'number',
      isMandatory: true,
      handleChange: onChangeRestrictDecimal,
      placeHolder: gRatePlaceHolder,
    },
    {
      fieldTitle: 'Maximum G_Rate',
      fieldName: 'grateMaximum',
      type: 'number',
      isMandatory: true,
      handleChange: onChangeRestrictDecimal,
      placeHolder: gRatePlaceHolder,
    },
    {
      fieldTitle: 'G_Second Rate ($)',
      fieldName: 'gsecondRate',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Second Rate',
    },
    {
      fieldTitle: 'Minimum G_Term',
      fieldName: 'gtermMinimum',
      type: 'number',
      isMandatory: true,
      placeHolder: 'Enter G_term',
    },
    {
      fieldTitle: 'Maximum G_Term',
      fieldName: 'gtermMaximum',
      type: 'number',
      isMandatory: true,
      placeHolder: 'Enter G_term',
    },
    {
      fieldTitle: 'G_Early Termination Fee ($)',
      fieldName: 'gearlyTerminationFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Early Termination Fee',
    },
    {
      fieldTitle: 'G_Service Fee ($)',
      fieldName: 'gserviceFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_service Fee',
    },
    {
      fieldTitle: 'G_Adder ($)',
      type: 'number',
      fieldName: 'gadded',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Adder',
    },
    {
      fieldTitle: 'G_Deposit ($)',
      type: 'number',
      fieldName: 'gdeposit',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter G_Deposit',
    },
    {
      fieldTitle: 'G_Product Code',
      type: 'text',
      fieldName: 'gcode',
      isMandatory: true,
      placeHolder: 'Enter G_product Code',
    },
    {
      fieldTitle: 'G_Billing Method',
      type: 'DROPDOWN',
      fieldName: 'gbillingMethod',
      isMandatory: true,
      data: billingMethodOptions,
    },
  ]
  const gasProduct = isDynamicProducts ? dynamicgasConfigs : gasConfigs
  return (
    <>
      <div className='fw-bold fs-6 mb-2 mt-4' style={{ color: '#5E6278' }}>
        <img src={ElectricIcon} alt='electric-icon' />
        Gas Property
      </div>
      <div className='property gas-property p-5'>
        <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
          {gasProduct.map((value: productFieldConfig) => {
            const { fieldName, fieldTitle, type, data, handleChange, isMandatory, placeHolder } =
              value
            return type === 'DROPDOWN' ? (
              <Col className='mb-4' sm md lg={6}>
                <label className={`d-flex align-items-center mb-2 ${isMandatory && 'required'}`}>
                  <span className='fs-6 fw-semibold lh-23'>{fieldTitle}</span>
                </label>
                <Dropdown
                  fieldName={fieldName}
                  optionList={data}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                  className='bg-white'
                />
              </Col>
            ) : (
              <Col className='mb-4' sm md lg={6}>
                <label className={`d-flex align-items-center mb-2 ${isMandatory && 'required'}`}>
                  <span className='fs-6 fw-semibold lh-23'>{fieldTitle}</span>
                </label>
                <input
                  type={type}
                  className='form-control form-control-lg form-control-solid bg-white'
                  placeholder={placeHolder}
                  id={fieldName}
                  onWheel={(event: any) => {
                    event.target.blur()
                  }}
                  {...formik.getFieldProps(fieldName)}
                  onChange={(e) => {
                    handleChange
                      ? handleChange(e, fieldName)
                      : formik.setFieldValue(fieldName, e.target.value)
                  }}
                />
                {formik.errors[fieldName] && formik.touched[fieldName] && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors[fieldName]}
                    </div>
                  </div>
                )}
              </Col>
            )
          })}
        </Row>
      </div>
    </>
  )
}
export default GasProperty
